import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export enum PostPurchaseYearsEnum {
  _0_to_1 = '0-1',
  _1_to_3 = '1-3',
  _3_to_5 = '3-5',
  _5_or_more = '5+',
}

export enum PostPurchasePriorityEnum {
  save_time = 'save_time',
  stay_organized = 'stay_organized',
  get_paid_faster = 'get_paid_faster',
  win_more_business = 'win_more_business',
}

export enum PostPurchaseStateEnum {
  completed = 'completed',
  dismissed = 'dismissed',
}

export const POST_PURCHASE_INFO_SCHEMA = Object.freeze({
  YEARS_IN_BUSINESS: null, // PostPurchaseYearsEnum
  PRIORITY: null, // PostPurchasePriorityEnum
  DATE_COMPLETED: null, // i2g-date-time (yyyy-mm-dd'T'hh:mm:ssZ)
  STATE: null, // PostPurchaseStateEnum
});
const RECORD = generateSchema(POST_PURCHASE_INFO_SCHEMA);
const KEYS: any = generateKeys(POST_PURCHASE_INFO_SCHEMA);

export class PostPurchaseInfo extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get yearsInBusiness(): PostPurchaseYearsEnum {
    return this.get(KEYS.YEARS_IN_BUSINESS);
  }

  get priority(): PostPurchasePriorityEnum {
    return this.get(KEYS.PRIORITY);
  }

  get dateCompleted(): string {
    return this.get(KEYS.DATE_COMPLETED);
  }

  get state(): PostPurchaseStateEnum {
    return this.get(KEYS.STATE);
  }

  isSurveyDone(): boolean {
    return [
      PostPurchaseStateEnum.completed,
      PostPurchaseStateEnum.dismissed,
    ].includes(this.state);
  }
}
